module.exports = __webpack_public_path__ + "static/row-the-future-1-7f366a82899ad5322cff845b4dd0c6a1.png";